export default "__VITE_ASSET__w_CWHDKl__"